"use client";

import { useEffect } from "react";
import { useInterestCountsStore } from "@/lib/store/interest-counts-store";
import { fetchInterestCounts } from "@/lib/api";

const POLL_MS = 20000;
// Tope defensivo del tamaño del pedido — con el registro por IntersectionObserver
// (ver InterestButton) esto casi nunca debería alcanzarse, pero evita una
// query string gigante en el caso extremo de una pantalla enorme mostrando
// muchísimas cards visibles a la vez.
const MAX_SLUGS_PER_POLL = 150;

// Refresca en vivo los conteos de "Me interesa" de los eventos que están
// REALMENTE visibles en pantalla (cada InterestButton se registra/desregistra
// según IntersectionObserver, no según mount/unmount — así "Cargar más" no
// hace crecer el pedido sin límite). Un solo timer global en vez de uno por
// card — evita N requests independientes por página.
export function InterestCountsPoller() {
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      const slugs = Object.keys(useInterestCountsStore.getState().registered).slice(0, MAX_SLUGS_PER_POLL);
      if (!slugs.length) return;
      fetchInterestCounts(slugs)
        .then((counts) => useInterestCountsStore.getState().mergeCounts(counts))
        .catch(() => {});
    }, POLL_MS);
    return () => clearInterval(interval);
  }, []);

  return null;
}
